import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
import { useAppContext } from '../context/AppContext';
export const GATE_DEFINITIONS = {
  newDashboard: gate('Marketplace::Storefront::NewDashboard'),
  tabularSearch: gate('Marketplace::Storefront::TabularSearch'),
  techPartnerTier: gate('Marketplace::Apps::TechPartnerTier')
};
function getGates() {
  try {
    return userInfoSync().gates;
  } catch (_unused) {
    return [];
  }
}
export function useGates() {
  const gates = getGates();
  const appContext = useAppContext();
  const isPublic = appContext === 'public';
  return useMemo(() => Object.assign({}, Object.fromEntries(Object.entries(GATE_DEFINITIONS).map(([k, g]) => [k, gates.includes(g)])), {
    newDashboard: isPublic || gates.includes(GATE_DEFINITIONS.newDashboard)
  }), [gates, isPublic]);
}